import { render } from "./CategorySearch.vue?vue&type=template&id=35babd4e"
import script from "./CategorySearch.vue?vue&type=script&lang=js"
export * from "./CategorySearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__